export default __webpack_public_path__ + "static/media/PrimaryButtonRect1.eff6ebd7.svg";